import CredentialAuth from "@/components/auth/CredentialAuth";

export default function Login() {
  return (
    <CredentialAuth
      role="member"
      eyebrow="Member access"
      title="Member Portal"
      description="Sign in or create your account to build your scorecard, complete onboarding and follow your personalised training plan."
      allowRegister
      allowGoogle
      notice="Previously used Google sign in? Choose “Forgot / first-time password” to securely set a password on the same email."
    />
  );
}
